import 'es6-symbol/implement'; //ponyfills Symbol for IE. Observe uses Symbol
import Observe from 'observe';
import root from 'window-or-global';

if (!root._epicGamesFooterObserverCallbacks) {
    root._epicGamesFooterObserverCallbacks = [];
}


/**
 * Set the defaults for the config. If testing make sure to restore the defaults to good production settings.
 *  It is probably best to not use this for testing.
 *
 * Test config has moved!! Please use /scripts/components/test/testConfig.js instead!
 */
const defaultConfig = {
    //theme name must match with a key in epic-games-header constants/properties
    epicPropertyName: 'epic_games',

    //sets the app links
    links: [], // [{title: 'Heroes', href: 'https://www.google.com'}]

    //sets the social links
    socialLinks: [], // [{id: 'youtube', href: 'https://www.youtube.com/c/paragon'}]

    //sets the logos to use
    logos: ['eg', 'ue'], // ['eg', 'ue', 'pcGame', 'ps4', 'sony', 'chair', 'badRobot', 'ps', 'oculus']

    legalTags: [], // [{ title: 'US/Canada', src: 'https://cdn3.unrealengine.com/foo' }]

    copyrights: [
        '© {YEAR}, Epic Games, Inc. Epic Games, Paragon, Unreal, Unreal Engine 4, UE4, and their respective logos are trademarks or registered trademarks of Epic Games, Inc. in the United States of America and elsewhere. All rights reserved.' //eslint-disable-line max-len
    ],

    callToAction: {}
};

//Loop over the epicGamesNav object and plug in any missing keys from the defaultConfig
if (!root._epicGamesFooter) {
    root._epicGamesFooter = defaultConfig;
} else {
    for (const key in defaultConfig) {
        if (key && typeof key === 'string') {
            if (!Object.hasOwnProperty.call(root._epicGamesFooter, key)) {
                root._epicGamesFooter[key] = defaultConfig[key];
            }
        }
    }
}

root._epicGamesFooterObserver = Observe(root._epicGamesFooter);
root._epicGamesFooterObserver.on('change', (change) => {
    if (root._epicGamesFooterObserverCallbacks && root._epicGamesFooterObserverCallbacks.length) {
        for (let i = 0; i < root._epicGamesFooterObserverCallbacks.length; i += 1) {
            const callback = root._epicGamesFooterObserverCallbacks[i];
            if (callback && typeof callback === 'function') {
                callback(change);
            }
        }
    }
});

root._epicGamesFooterObserverCreated = true;

const addObserverCallback = (fn) => {
    if (typeof fn === 'function') {
        root._epicGamesFooterObserverCallbacks.push(fn);
    }
};

export default addObserverCallback;



// WEBPACK FOOTER //
// ./app/scripts/utils/epicGamesFooterObserver.js